export default "__VITE_PUBLIC_ASSET__36b94308__"